import type { LucideIcon } from "lucide-react";
import { Archive, FileEdit, Folder as FolderIcon, Inbox, OctagonAlert, Send, Trash2 } from "lucide-react";
import type { SystemFolderSlug } from "@onemileauto/shared-types";

const SYSTEM_FOLDER_ICONS: Record<SystemFolderSlug, LucideIcon> = {
  inbox: Inbox,
  archive: Archive,
  sent: Send,
  drafts: FileEdit,
  trash: Trash2,
  spam: OctagonAlert,
};

/** Shared by folder-nav.tsx and move-to-folder-sheet.tsx so both folder pickers render identically. Any custom (non-system) folder falls back to a plain folder glyph. */
export function iconForFolderSlug(slug: string): LucideIcon {
  return SYSTEM_FOLDER_ICONS[slug as SystemFolderSlug] ?? FolderIcon;
}
